import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-d-small', 'LetterDSmall', [["path",{"d":"M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z","key":"svg-0"}]]);